import type { Action } from '@0xtorch/core'
import type { TransactionDetail } from '../schemas/transactionDetail'
import type { SplTokenDatasource } from '../splTokenDatasource'
import { createTokenAccounts } from './createTokenAccounts'
import { createTokenTransfers } from './createTokenTransfers'
import { generateNormalActions } from './generateNormalActions'
import type { AnalyzedSolanaTransaction, JsonDatasource } from './types'

type AnalyzeSolanaTransactionParameters = {
  readonly transaction: TransactionDetail
  readonly tokenAccountOwnerMap: { [account: string]: string | undefined }
  readonly splTokenDatasource: SplTokenDatasource
  readonly jsonDatasource: JsonDatasource
  readonly accountIds: readonly string[]
}

export const analyzeSolanaTransaction = async ({
  transaction,
  tokenAccountOwnerMap,
  splTokenDatasource,
  jsonDatasource,
  accountIds,
}: AnalyzeSolanaTransactionParameters): Promise<AnalyzedSolanaTransaction> => {
  // Create token account list
  const tokenAccounts = createTokenAccounts(transaction)

  // Create token transfer list
  const tokenTransfers =
    transaction.meta?.err === null
      ? createTokenTransfers({ transaction, tokenAccounts })
      : []

  // transaction を解析して action 生成
  const actions = await generateNormalActions({
    transaction,
    tokenTransfers,
    tokenAccounts,
    tokenAccountOwnerMap,
    splTokenDatasource,
    jsonDatasource,
    accountIds,
  })

  return {
    transaction,
    actions: resetActionsOrder(actions),
  }
}

const resetActionsOrder = (actions: readonly Action[]): readonly Action[] =>
  actions.map((action, index) => {
    action.order = index
    return action
  })
